export default "__VITE_ASSET__msxria2H__"